import React from 'react'
import ScalePopup from '../Overlays/ScalePopup'
import './SetScalePopup.css'

const SetScalePopup = () => {
  return (
    <div className='set-scale-popup'>
      <ScalePopup />
    </div>
  )
}

export default SetScalePopup
